import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "contrast", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var Typography = function Typography(_ref) {
  var color = _ref.color,
      contrast = _ref.contrast,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);

  var transformColor = !color || color === 'inherit' ? color : contrast ? "".concat(color, ".contrastText") : "".concat(color, ".main");
  return /*#__PURE__*/_jsx(MuiTypography, _objectSpread(_objectSpread({}, props), {}, {
    color: transformColor,
    variant: variant
  }));
};